var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import Spinner from "../spinner/spinner";
import "./button.styles.scss";
/**
 * Button Stateless Functional Component.
 * @param props {IButtonProps} props for button component.
 * @returns Button component with styling corresponding to 'btnType'
 */
var Button = function (props) {
    var btnType = props.btnType, shape = props.shape, isLoading = props.isLoading, icon = props.icon, title = props.title, onClick = props.onClick, tip = props.tip;
    var getButtonClass = function () {
        return (btnType || "basic") + "-" + (shape || "round") + "-button";
    };
    if (shape === "circular") {
        return (React.createElement("button", __assign({ className: getButtonClass() }, props, { onClick: isLoading ? undefined : onClick }), isLoading ? (React.createElement(Spinner, { color: "#fff" })) : (React.createElement("img", { className: "btn-icon", src: icon, alt: "icon" }))));
    }
    return (React.createElement("button", __assign({ className: getButtonClass() }, props, { title: tip, onClick: isLoading ? undefined : onClick ? onClick : undefined }), isLoading ? React.createElement(Spinner, { color: "#fff" }) : title));
};
export default Button;
//# sourceMappingURL=button.js.map